import React, { useState, useEffect } from 'react'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { ah, sh, compose, ReduxWrapper } from 'common-data/datahelpers'
import { FAIcon } from './FAIcon'
import { Grid } from './Grid'
import { GridCell } from './GridCell'
import { FileImg } from './FileImg'
import { useParseOnClick } from 'common-controls/Core/Hooks/useParseOnClick'
import { useParseChildMap } from 'common-controls/Core/Hooks/useParseChildMap'
// import posed from 'react-pose'
import _ from 'common-tools/LodashHelper'
import clsx from 'clsx'

import styles from './DataCard.less'

export const DataCard = compose(
  ReduxWrapper([

  ],
  [
    ah.sendToURL,
    ah.addLayoutContentBreadCrumbKey
  ])
)(function DataCardPlain (props) {
  const { onClick, sendToURL, addLayoutContentBreadCrumbKey, children, showSelected, className } = props

  const [onClickFunction] = useParseOnClick(onClick, sendToURL, addLayoutContentBreadCrumbKey)

  const emptyChildMap = { Title: [], SubTitle: [], Picture: [], Icon: [], ActionRow: [], SelectRow: [], LockedRow: [], BufferRow: [], ContentRow: [] }
  const [childMap] = useParseChildMap(children, emptyChildMap, 'ContentRow')

  const [footerClasses, setFooterClasses] = useState('')

  useEffect(() => {
    setFooterClasses(childMap.ActionRow?.length > 0 ? 'generic2-foot' : 'generic-foot')
  }, [childMap])

  return <GridCell className={className}>
    <div className="grow-tiny">
      <a onClick={onClickFunction.func}>
        <div className="tool-card">
          <Grid>
            <GridCell auto className="generic2-title">{childMap.Title}</GridCell>
            <GridCell shrink className="generic2-ico">
              {childMap.SelectRow}
              {childMap.LockedRow}
            </GridCell>
            <GridCell className={clsx('generic2-body', 'equalize-watch', showSelected && styles.selected)}>
              {childMap.SubTitle}
              {childMap.ContentRow}
            </GridCell>
            <GridCell className={footerClasses}>
              <Grid hide={childMap.ActionRow.length === 0}>
                <GridCell small={4} className="generic2-ico-foot">
                  {childMap.ActionRow}
                </GridCell>
                <GridCell auto className="generic2-mini-txt">&nbsp;</GridCell>
                {/* <GridCell auto className="text-right">
                  <span className="fa-stack fa-sm">
                    <span className="fa fa-circle fa-stack-2x"></span>
                    <span className="fa-stack-1x fa-inverse">36</span>
                  </span>
                </GridCell> */}
              </Grid>
            </GridCell>
          </Grid>
        </div>
      </a>
    </div>
  </GridCell>
})

// export class DataCardPlain2 extends React.Component {
//   static pt = {
//     picture: pt.shape({
//       key: pt.string,
//       icon: pt.string
//     }),
//     children: pt.element,
//     loading: pt.bool.isRequired,
//     rowSpan: pt.number.isRequired,
//     colSpan: pt.number.isRequired,
//     showGray: pt.bool,
//     showSelected: pt.bool,
//     onClick: pt.oneOfType([
//       pt.func,
//       pt.string,
//       pt.shape({
//         url: pt.string,
//         breadCrumbKey: pt.shape({
//           key: pt.string,
//           value: pt.string
//         })
//       })
//     ])
//   }

//   static defaultProps = {
//     loading: false,
//     rowSpan: 2,
//     colSpan: 2,
//     showGray: false,
//     showSelected: false
//   }

//   render () {
//     const { 'data-tid': testId = '', rowSpan, colSpan, children, onClick, sendToURL, addLayoutContentBreadCrumbKey, showGray, showSelected, noCursor } = this.props

//     const cardStyle = {}

//     if (rowSpan > 1) {
//       cardStyle.gridRowEnd = `span ${rowSpan}`
//     }

//     if (colSpan === 0) {
//       cardStyle.gridColumnStart = 1
//       cardStyle.gridColumnEnd = -1
//     } else if (colSpan > 1) {
//       cardStyle.gridColumnEnd = `span ${colSpan}`
//     }

//     let onClickFunction = null

//     if (_.isFunction(onClick)) {
//       onClickFunction = onClick
//     } else if (_.isString(onClick)) {
//       onClickFunction = () => {
//         sendToURL(onClick)
//       }
//     } else if (_.isPlainObject(onClick)) {
//       onClickFunction = () => {
//         sendToURL(onClick.url)
//         if (onClick.breadCrumbKey) {
//           addLayoutContentBreadCrumbKey(onClick.breadCrumbKey.key, onClick.breadCrumbKey.value)
//         }
//       }
//     }
//     return (
//       <div style={cardStyle} data-tid={testId} className={clsx({
//         [styles.datacard]: true,
//         [styles.disabled]: showGray,
//         [styles.selected]: showSelected,
//         [styles.datacardNoCursor]: noCursor,
//         'hvr-underline-from-center': true
//       })} onClick={onClickFunction}>
//         {children}
//       </div>
//     )
//   }
// }

export function DataCardSelectCheckRow (props) {
  const { onClick, selected } = props

  function handleClick (e) {
    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    if (_.isFunction(onClick)) {
      onClick()
    }
  }

  return selected ? <i onClick={handleClick} className="fas fa-check-circle fa-lg" /> : <i onClick={handleClick} className="fas fa-circle fa-lg"></i>
}
DataCardSelectCheckRow.DCType = 'SelectRow'

export function DataCardLockedRow (props) {
  // static propTypes = buildPropTypes([
  // ], {
  //   color: pt.string,
  //   size: pt.string,
  //   toolTip: pt.string.isRequired,
  //   icon: pt.string
  // })

  const { toolTip, icon = 'lock' } = props

  return <FAIcon name={icon} className='fa-lg' toolTip={toolTip || 'This item is locked'} placement='bottomRight' />
}
DataCardLockedRow.DCType = 'LockedRow'

export const DataCardActionsRow = compose(
  ReduxWrapper([
    sh.SessionUser,
    sh.SessionAccount
  ])
)(function DataCardActionsRowPlain (props) {
  const { actions, SessionAccount, SessionUser } = props

  const [allowedActions, setAllowedActions] = useState([])

  useEffect(() => {
    if (_.isArray(actions) === false || actions.length === 0) {
      setAllowedActions([])
    } else {
      const matchActions = _.filter(actions, (action) => {
        if (_.isArray(actions.permissions)) {
          return SessionAccount.HasPermissions(action.permissions) || SessionUser.HasPermissions(action.permissions)
        } else {
          return true
        }
      })
      setAllowedActions(matchActions)
    }
  }, [actions])

  // static propTypes = buildPropTypes([
  //   sh.SessionAccount,
  //   sh.SessionUser
  // ], {
  //   actions: pt.arrayOf(pt.shape({
  //     toolTip: pt.string,
  //     icon: pt.string,
  //     color: pt.string,
  //     onClick: pt.func
  //   })),
  //   grouped: pt.bool
  // })

  // static defaultProps = {
  //   actions: [],
  //   grouped: false
  // }

  const handleClick = (actionClick) => (e) => {
    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    if (_.isFunction(actionClick)) {
      actionClick()
    }
  }

  return _.map(allowedActions, (a, i) => (<FAIcon name={a.icon} className={styles.iconPadding} onClick={handleClick(a.onClick)} key={i} toolTip={a.toolTip} />))
})
DataCardActionsRow.DCType = 'ActionRow'

export const DataCardBufferRow = ({ skip }) => {
  const bufferStyle = {
    gridRowEnd: `span ${skip || 1}`
  }

  return <div style={bufferStyle} className='bufferRow'></div>
}
DataCardBufferRow.DCType = 'BufferRow'

export const DataCardIcon = ({ name, color, size, rowSpan }) => {
  this.DCType = 'Icon'

  const iconStyle = {
    gridRowEnd: `span ${rowSpan || 1}`
  }

  return <div style={iconStyle} className={`iconRow text-${color || 'purple'}`}>
    <FAIcon name={name} size={size || '12px'} />
  </div>
}
DataCardIcon.DCType = 'Icon'

export const DataCardTitle = ({ children }) => {
  return children
}
DataCardTitle.DCType = 'Title'

export const DataCardSubTitle = ({ children }) => {
  return <div>{children}</div>
}
DataCardSubTitle.DCType = 'SubTitle'

class DataCardPicturePlain extends React.Component {
  static DCType = 'Picture'

  static propTypes = buildPropTypes([
    sh.SessionToken
  ], {
    icon: pt.string,
    pictureKey: pt.string,
    color: pt.string,
    size: pt.string,
    rowSpan: pt.number,
    heightWidth: pt.number
  })

  static defaultProps = {
    color: 'purple',
    icon: 'user',
    size: '24px',
    rowSpan: 0,
    heightWidth: 80
  }

  render () {
    const { pictureKey, icon, size, rowSpan, SessionToken, heightWidth, color } = this.props

    const pictureStyle = {}

    if (rowSpan === 0) {
      pictureStyle.gridRowEnd = -1
    } else if (rowSpan > 1) {
      pictureStyle.gridRowEnd = `span ${rowSpan}`
    }

    return <div style={pictureStyle} className='pictureRow'>
      <div style={{ height: `${heightWidth}px`, width: `${heightWidth}px`, borderRadius: `${heightWidth}px` }} className='pictureWrapper'>
        {pictureKey
          ? <FileImg style={{ maxHeight: `${heightWidth + 10}px`, maxWidth: `${heightWidth + 10}px` }} pictureKey={pictureKey} SessionToken={SessionToken} />
          : <FAIcon name={icon} size={size} color={color} type='d'/>
        }
      </div>
    </div>
  }
}

export const DataCardPicture = compose(
  ReduxWrapper([
    sh.SessionToken
  ])
)(DataCardPicturePlain)
